module.exports = __webpack_public_path__ + "img/play_color.6e99bdc2.svg";